import { BaseDto } from './base.dto';
import { FloorPlanDto } from './floor-plan';
import { MerchantDto } from './merchant.dto';
import { MerchantSaleUnitDto } from './merchantSaleUnit.dto';

export class MerchantSaleRoomDto extends BaseDto {
  name: string;
  height?: number;
  width?: number;
  length?: number;
  area?: string;
  naturalLight?: boolean;
  wifi?: boolean;
  allowPOSTableService?: boolean;
  allowOrderAtTable?: boolean;
  allowBookings?: boolean;
  roomTypeId: number;
  avAvailable: boolean;
  merchant: MerchantDto;
  saleUnits?: MerchantSaleUnitDto[];  
  sequence?: number;
  floorPlan?: FloorPlanDto
}
